import { createSlice } from '@reduxjs/toolkit';

const volatileSlice = createSlice({
    name: 'volatile',
    initialState: {},
    reducers: {}
});

export default volatileSlice.reducer;
